import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Github, Linkedin, Twitter } from 'lucide-react';

const TeamSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const teamMembers = [
    {
      name: 'Mario McLaughlin',
      role: 'CEO & Founder',
      bio: 'Former agtech executive with 10+ years in sustainable farming and blockchain innovation.',
      avatar: '/images/team/mario.jpg',
      social: {
        twitter: '',
        linkedin: 'https://www.linkedin.com/in/mario-m-78773647/',
        github: '',
      },
    },
  ];

  return (
    <section id="team" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
            Meet Our <span className="gradient-text">Team</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Passionate experts from agriculture, blockchain, and sustainability 
            working together to transform the food industry.
          </p>
        </motion.div>

        <div className="flex justify-center">
          <div className="max-w-sm">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center"
            >
              <div className="relative mb-6">
                <img
                  src={member.avatar}
                  alt={member.name}
                  className="w-24 h-24 rounded-full mx-auto object-cover ring-4 ring-primary-100"
                />
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-1">
                {member.name}
              </h3>
              
              <p className="text-primary-600 font-medium mb-4">
                {member.role}
              </p>
              
              <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                {member.bio}
              </p>
              
              <div className="flex justify-center space-x-3">
                {member.social.twitter && (
                  <a
                    href={member.social.twitter}
                    className="p-2 bg-gray-100 rounded-lg hover:bg-primary-100 hover:text-primary-600 transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Twitter className="w-4 h-4" />
                  </a>
                )}
                {member.social.linkedin && (
                  <a
                    href={member.social.linkedin}
                    className="p-2 bg-gray-100 rounded-lg hover:bg-primary-100 hover:text-primary-600 transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Linkedin className="w-4 h-4" />
                  </a>
                )}
                {member.social.github && (
                  <a
                    href={member.social.github}
                    className="p-2 bg-gray-100 rounded-lg hover:bg-primary-100 hover:text-primary-600 transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Github className="w-4 h-4" />
                  </a>
                )}
              </div>
            </motion.div>
          ))}
          </div>
        </div>

        {/* Advisory Section */}
        {/* <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-20 text-center"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-8">
            Backed by Industry Leaders
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 opacity-60">
            {[
              'AgTech Ventures',
              'Green Future Fund',
              'Blockchain Capital',
              'Sustainable Food Alliance',
            ].map((advisor, index) => (
              <motion.div
                key={advisor}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: 0.6 + index * 0.1 }}
                className="text-gray-500 font-medium"
              >
                {advisor}
              </motion.div>
            ))}
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default TeamSection;